import { ApiServiceV1 } from '@services/api.service';

export default {
  async getEnums() {
    const { data } = await ApiServiceV1.get('enum');
    return data;
  },
};
